import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { PlusAuthenticationService } from '@karve.it/core';
import { Observable } from 'rxjs';

import { FREYA_ROUTES } from './global.constants';

import { FreyaNotificationsService } from './services/freya-notifications.service';

@Injectable({
  providedIn: 'root'
})
export class UserAuthGuard  {

  public constructor(
    private auth: PlusAuthenticationService,
    private localNotify: FreyaNotificationsService,
    private router: Router,
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Wait for the bootstrap auth check to complete before deciding.
    // This prevents a redirect loop when the FA callback set httpOnly
    // cookies but localStorage hasn't been hydrated yet.
    // bootstrapAuth() (not the raw field) so a deauthentication — which
    // invalidates the cached promise — triggers a fresh cookie-based check
    // instead of a TypeError on undefined.
    return this.auth.bootstrapAuth().then((authenticated) => {
      if (!authenticated) {
        // Capture the original URL so we can redirect back after login.
        if (state.url && state.url !== '/' && state.url !== '/auth/login') {
          localStorage.setItem('pre_login_url', state.url);
        }
        return this.router.parseUrl(FREYA_ROUTES.login);
      }
      return true;
    });
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(route, state);
  }
}
